export default __webpack_public_path__ + "static/media/carritocompras.6b2facd4.png";